<template xmlns="http://www.w3.org/1999/html">
  <div>
    <div style="display:inline; text-align: right">
      <el-dropdown>
        <i class="el-icon-setting" style="margin-right: 15px"></i>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="exitHandler">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <span>{{userdata.phone}}</span>
    </div>
    <div style="float: left">手机号：{{userdata.phone}}&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
      昵称:{{userdata.nickname}}&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
      代理地址:&nbsp&nbsp<el-link type="primary" :href=" 'http://' + userdata.url" :underline="false">{{userdata.url}}</el-link>&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
      领卡地址:&nbsp&nbsp<el-link type="primary" :href=" 'http://' + userdata.host + 'k.shenka.top' " :underline="false">{{userdata.host}}k.shenka.top</el-link></div>
  </div>

</template>

<script>
import request from "@/request/request";

export default {
  name: 'Header',
  data() {
    return {
      userdata:'',
    }
  },
  created() {
    this.req();
  },
  methods: {
    exitHandler(){
      this.$router.push('/')
    },

    req(){
      let str = `/proxy/system/user`
      request.get(str).then(res => {
        this.userdata = res.data
      }).catch(e => {
        this.$message.error(e.message);
      })
    }
  }
}
</script>

<style scoped>

</style>
